export default __webpack_public_path__ + "static/media/dark_horizontal_menu.d1135808.svg";